import styles from "./Checkbox.module.scss";
import clsx from "clsx";
import { CheckIcon } from "@/frontend/shared/assets/icons";
import { Typography } from "../Typography/Typography";
import { Dispatch, SetStateAction, type ReactNode, MouseEvent } from "react";

type TCheckboxProps = {
  label?: string | ReactNode;
  value: boolean;
  onChange: Dispatch<SetStateAction<boolean>>;
  className?: string;
  labelClassName?: string;
  isTableLabel?: boolean;
  id?: string;
};

export function Checkbox({
  label,
  value,
  onChange,
  className,
  labelClassName,
  isTableLabel = false,
  id
}: TCheckboxProps) {
  function toggleCheckbox(e: MouseEvent) {
    e.stopPropagation();
    onChange((prev) => !prev);
  }

  return (
    <div
      className={clsx(styles.checkboxContainer, className)}
      onClick={(e: MouseEvent) => {
        toggleCheckbox(e);
      }}
      id={id}
    >
      <div className={clsx(styles.checkbox, value && styles.checked, !value && isTableLabel && styles.tableLabel)}>
        {value && <CheckIcon className={styles.checkmark} />}
      </div>
      {label && (
        <Typography variant="label-4" color="greyscale900" className={clsx(styles.label, labelClassName)}>
          {label}
        </Typography>
      )}
    </div>
  );
}
